<div class="ms-20 me-20">
    <div class="my-20">
        Add Vitals
    </div>
    <form [formGroup]="vitalsFormGroup">
        <!--appearance-->
        @if((vitalsComponents && vitalsComponents.length > 0

        && vitalsComponents.includes('appearance')
        ) || isAllComponent || (!vitalsComponents && !isAllComponent)
        ){
        <div class="appearance">
            <mat-form-field appearance="outline" class="me-30 mb-20" floatLabel="always">
                <mat-label>Patient Appearance</mat-label>
                <mat-select formControlName="appearance">
                    @for(option of ['Well', 'Unwell', 'Pale', 'Flushed', 'Icteric',
                    'Lethargic', 'Active', 'Agitated', 'Calm', 'Compliant', 'Combative'
                    ]; track $index;){
                    <mat-option value="{{option}}">
                        {{option}}
                    </mat-option>

                    }
                </mat-select>
                <mat-icon matIconPrefix>face</mat-icon>
            </mat-form-field>
        </div>


        }
        <!--gait-->
        @if((vitalsComponents && vitalsComponents.length > 0

        && vitalsComponents.includes('gait')
        ) || isAllComponent || (!vitalsComponents && !isAllComponent)
        ){
        <div class="gait">
            <mat-form-field appearance="outline" class="me-30 mb-20" floatLabel="always">
                <mat-label>Patient Gait</mat-label>
                <mat-select formControlName="gait">
                    @for(option of ['Walks Normally', 'Walks with Support', 'Walks with Limp', 'Unable to Walk']
                    ; track $index;){
                    <mat-option value="{{option}}">
                        {{option}}
                    </mat-option>

                    }
                </mat-select>
                <mat-icon matIconPrefix>directions_walk</mat-icon>
            </mat-form-field>
        </div>
        }
        

        @if((vitalsComponents && vitalsComponents.length > 0

        && vitalsComponents.includes('bmi')
        ) || isAllComponent || (!vitalsComponents && !isAllComponent)
        ){
        <div class="bmi" style="flex: 1 0 100%;">
            <div class="fields">

                <div class="field-item g-just-flex flex-column"
                style="width: max-content;"
                >
                <mat-form-field appearance="outline" class="me-0 mb-0" floatLabel="always"
                 style="height: max-content; flex: 0 0 max-content"
                >
                    <mat-label>Patient Height</mat-label>
                    <input type="number" matInput #height formControlName="height">
                    <mat-icon matIconPrefix>height</mat-icon>
                    <span class="unit" matTextSuffix>cm</span>
                    @let hCtrl = vitalsFormGroup.get(['height']);
                    @if(hCtrl?.touched && hCtrl?.errors){
                    <mat-error class="small-subtitle">
                        @if(hCtrl?.errors?.['requirePair']){
                        <div>Height is required when weight is provided.</div>
                        }
                        @if(hCtrl?.errors?.['heightInvalid']){
                        <div>Enter a valid height in cm (greater than 0).</div>
                        }
                    </mat-error>
                    }
                </mat-form-field>
                @if(heightSuggestion && heightSuggestion.range){
                <div class="ref-range-hint small-subtitle" style="flex: 1 " >
                    <mat-icon [style.color]="heightIndicator?.color || (heightSuggestion.classification==='high'? '#f44336': heightSuggestion.classification==='low'? '#2196F3':'#4caf50')">{{heightIndicator?.icon || (heightSuggestion.classification==='high' ? 'arrow_upward' : (heightSuggestion.classification==='low' ? 'arrow_downward' : 'check_circle'))}}</mat-icon>
                    {{heightIndicator?.category || heightSuggestion.classification}} — {{heightSuggestion.description}}
                </div>
                }
                </div>
                <div class="field-item g-just-flex flex-column gap-12"
                style="width: max-content; ">
                <mat-form-field appearance="outline" class="me-0 mb-0" floatLabel="always"
                style="height: max-content; flex: 0 0 max-content"
                >
                    <mat-label>Patient Weight</mat-label>
                    <input type="number" matInput #weight formControlName="weight">
                    <mat-icon matIconPrefix>monitor_weight</mat-icon>
                    <span class="unit" matTextSuffix>kg</span>
                    @let wCtrl = vitalsFormGroup.get(['weight']);
                    @if(wCtrl?.touched && wCtrl?.errors){
                    <mat-error class="small-subtitle">
                        @if(wCtrl?.errors?.['requirePair']){
                        <div>Weight is required when height is provided.</div>
                        }
                        @if(wCtrl?.errors?.['weightInvalid']){
                        <div>Enter a valid weight in kg (greater than 0).</div>
                        }
                    </mat-error>
                    }
                </mat-form-field>
                @if(weightSuggestion && weightSuggestion.range){
                <div class="ref-range-hint small-subtitle">
                    <mat-icon [style.color]="weightIndicator?.color || (weightSuggestion.classification==='high'? '#f44336': weightSuggestion.classification==='low'? '#2196F3':'#4caf50')">{{weightIndicator?.icon || (weightSuggestion.classification==='high' ? 'arrow_upward' : (weightSuggestion.classification==='low' ? 'arrow_downward' : 'check_circle'))}}</mat-icon>
                    {{weightIndicator?.category || weightSuggestion.classification}} — {{weightSuggestion.description}}
                </div>
                }
                </div>
                        @if(bmiIndicator || bmiSuggestion){
                        <div class="ref-range-hint small-subtitle">
                            <mat-icon [style.color]="bmiIndicator?.color || '#9e9e9e'">{{bmiIndicator?.icon || 'info'}}</mat-icon>
                            {{bmiIndicator?.category || bmiSuggestion?.classification}} — {{bmiSuggestion?.description}} <span class="small-muted">(BMI: {{patientBMI?.toFixed(2)}})</span>
                        </div>
                        }
            </div>
            @if(height && weight && height.value && weight.value &&
            patientBMI && patientBMICategory && bmiBands && bmiBands.length > 0
            ){
            <div class="meter-background">
                <div class="meter-foreground">
                    @for(band of bmiBands; track $index;){
                    <div class="band" matTooltip="{{band.category}}" [matTooltipPosition]="'above'" [ngStyle]="{'background-color': band.color, 'width': ($first || $last)? ($first?(band.bmiRange[1]! - 0): (100 - band.bmiRange[0]!))+'%':
                            (band?.bmiRange?.[1] || 100) - (band?.bmiRange?.[0] || 0) +'%'}">



                    </div>
                    }
                    <div class="position-indicator" [ngStyle]="{'left': patientBMI < 100 ? patientBMI+ '%' : '98%'}">

                


                    </div>
                </div>
            </div>
            <!-- // POSITION iNDICATOR -->

            <div class="justify-content-start gap-12 g-just-flex indicator-text">

                <mat-icon [style.color]="patientBMICategory.color">{{patientBMICategory.icon}}</mat-icon>
                {{patientBMI.toFixed(2)+' kg/m²'}}
                <span class="category-text">
                    <!--patient-->
                    {{patientBMICategory.category}}
                </span>

            </div>


            }
        </div>
        }
        
        @if((vitalsComponents && vitalsComponents.includes('bloodPressure')) || isAllComponent || (!vitalsComponents &&
        !isAllComponent)
        ){
        <div class="blood-pressure" style="flex: 1 0 100%;">
            <mat-form-field appearance="outline" class="me-30 mb-0" floatLabel="always"
            style="max-width: 100%;"
            >
                <mat-label>Patient Blood Pressure</mat-label>
                <input type="text" matInput #bloodPressure formControlName="bloodPressure">
                <mat-icon matIconPrefix>monitor_heart</mat-icon>
                <span class="unit" matTextSuffix>mmHg</span>
            </mat-form-field>
            @let bpCtrl = vitalsFormGroup.get(['bloodPressure']);
            @if(bpCtrl?.touched && bpCtrl?.errors){
            @let errs = bpCtrl?.errors || {};
            <mat-error class="small-subtitle">
                @if(errs['bloodPressureFormat']){
                <div>
                    Please enter blood pressure in the format "systolic/diastolic" (e.g., 120/80).
                </div>
                }
                @if(errs['bloodPressureRange']){
                <div>
                    Value out of plausible range. Systolic {{bpRangeEffective.sys.min}}–{{bpRangeEffective.sys.max}}
                    and
                    Diastolic {{bpRangeEffective.dia.min}}–{{bpRangeEffective.dia.max}} mmHg allowed.
                </div>
                }
            </mat-error>
            }

            @if(systolicSuggestion || diastolicSuggestion){
            <div class="ref-range-hint small-subtitle">
                @if(systolicSuggestion){
                <div><strong>Systolic:</strong>
                    <mat-icon [style.color]="mapClassificationToIndicator(systolicSuggestion.classification)?.color || (systolicSuggestion.classification==='high'? '#f44336': systolicSuggestion.classification==='low'? '#2196F3':'#4caf50')">{{mapClassificationToIndicator(systolicSuggestion.classification)?.icon || (systolicSuggestion.classification==='high' ? 'arrow_upward' : (systolicSuggestion.classification==='low' ? 'arrow_downward' : 'check_circle'))}}</mat-icon>
                    {{mapClassificationToIndicator(systolicSuggestion.classification)?.category || systolicSuggestion.classification}} — {{systolicSuggestion.description}}
                </div>
                }
                @if(diastolicSuggestion){
                <div><strong>Diastolic:</strong>
                    <mat-icon [style.color]="mapClassificationToIndicator(diastolicSuggestion.classification)?.color || (diastolicSuggestion.classification==='high'? '#f44336': diastolicSuggestion.classification==='low'? '#2196F3':'#4caf50')">{{mapClassificationToIndicator(diastolicSuggestion.classification)?.icon || (diastolicSuggestion.classification==='high' ? 'arrow_upward' : (diastolicSuggestion.classification==='low' ? 'arrow_downward' : 'check_circle'))}}</mat-icon>
                    {{mapClassificationToIndicator(diastolicSuggestion.classification)?.category || diastolicSuggestion.classification}} — {{diastolicSuggestion.description}}
                </div>
                }
            </div>
            }

            @if(
            vitalsFormGroup.get(['bloodPressure'])?.value &&
            isBloodPressureValid(vitalsFormGroup.get(['bloodPressure'])?.value) &&
            patientBloodPressureCategory
            ){

            <div class="justify-content-start gap-12 g-just-flex indicator-text">
                <mat-icon
                    [style.color]="patientBloodPressureCategory.color">{{patientBloodPressureCategory.icon}}</mat-icon>
                {{vitalsFormGroup.get(['bloodPressure'])?.value + ' mmHg'}}
                <span class="category-text">
                    <!--patient-->
                    {{patientBloodPressureCategory.category}}
                </span>
            </div>
            }

        </div>
        }
        
        <!--temperature-->
        @if((vitalsComponents && vitalsComponents.includes('temperature')) || isAllComponent || (!vitalsComponents &&
        !isAllComponent)
        ){
        <div class="temperature">
            <mat-form-field appearance="outline" class="me-30 mb-20" floatLabel="always">
                <mat-label>Patient Temperature</mat-label>
                <input type="number" matInput #temperature formControlName="temperature">
                <mat-icon matIconPrefix>ac_unit</mat-icon>
                <span class="unit" matTextSuffix>°C</span>
            </mat-form-field>

            @if(temperatureIndicator || temperatureSuggestion){
            <div class="ref-range-hint small-subtitle">
                <mat-icon [style.color]="temperatureIndicator?.color || (temperatureSuggestion?.classification==='high'? '#f44336': temperatureSuggestion?.classification==='low'? '#2196F3':'#4caf50')">{{temperatureIndicator?.icon || (temperatureSuggestion?.classification==='high' ? 'arrow_upward' : (temperatureSuggestion?.classification==='low' ? 'arrow_downward' : 'check_circle'))}}</mat-icon>
                {{temperatureIndicator?.category || temperatureSuggestion?.classification}} — {{temperatureSuggestion?.description}}
            </div>
            }
        </div>
        }
        <!--pulseRate-->
        @if((vitalsComponents && vitalsComponents.includes('pulseRate')) || isAllComponent || (!vitalsComponents &&
        !isAllComponent)
        ){
        <div class="pulse-rate">
            <mat-form-field appearance="outline" class="me-20 mb-20" floatLabel="always">
                <mat-label>Patient Pulse Rate</mat-label>
                <input type="number" matInput #pulseRate formControlName="pulseRate">
                <mat-icon matIconPrefix>favorite</mat-icon>
                <span class="unit" matTextSuffix>bpm</span>
            </mat-form-field>

            @if(pulseRateIndicator || pulseRateSuggestion){
            <div class="ref-range-hint small-subtitle">
                <mat-icon [style.color]="pulseRateIndicator?.color || (pulseRateSuggestion?.classification==='high'? '#f44336': pulseRateSuggestion?.classification==='low'? '#2196F3':'#4caf50')">{{pulseRateIndicator?.icon || (pulseRateSuggestion?.classification==='high' ? 'arrow_upward' : (pulseRateSuggestion?.classification==='low' ? 'arrow_downward' : 'check_circle'))}}</mat-icon>
                {{pulseRateIndicator?.category || pulseRateSuggestion?.classification}} — {{pulseRateSuggestion?.description}}
            </div>
            }

        </div>
        }
        <!--respiratoryRate-->
        @if((vitalsComponents && vitalsComponents.includes('respiratoryRate')) || isAllComponent || (!vitalsComponents
        &&
        !isAllComponent)
        ){
        <div class="respiratory-rate">
            <mat-form-field appearance="outline" class="me-20 mb-20" floatLabel="always">
                <mat-label>Patient Respiratory Rate</mat-label>
                <input type="number" matInput #respiratoryRate formControlName="respiratoryRate">
                <mat-icon matIconPrefix>air</mat-icon>
                <span class="unit" matTextSuffix>bpm</span>
            </mat-form-field>
            @if(respiratoryRateIndicator || respiratoryRateSuggestion){
            <div class="ref-range-hint small-subtitle">
                <mat-icon [style.color]="respiratoryRateIndicator?.color || (respiratoryRateSuggestion?.classification==='high'? '#f44336': respiratoryRateSuggestion?.classification==='low'? '#2196F3':'#4caf50')">{{respiratoryRateIndicator?.icon || (respiratoryRateSuggestion?.classification==='high' ? 'arrow_upward' : (respiratoryRateSuggestion?.classification==='low' ? 'arrow_downward' : 'check_circle'))}}</mat-icon>
                {{respiratoryRateIndicator?.category || respiratoryRateSuggestion?.classification}} — {{respiratoryRateSuggestion?.description}}
            </div>
            }
        </div>
        }
        <!--oxygenSaturation-->
        @if((vitalsComponents && vitalsComponents.includes('oxygenSaturation')) || isAllComponent || (!vitalsComponents
        &&
        !isAllComponent)
        ){
        <div class="oxygen-saturation">
            <mat-form-field appearance="outline" class="me-2`0 mb-20" floatLabel="always">
                <mat-label>Patient Oxygen Saturation</mat-label>
                <input type="number" matInput #oxygenSaturation formControlName="oxygenSaturation">
                <mat-icon matIconPrefix>air</mat-icon>
                <span class="unit" matTextSuffix>Sp02</span>
            </mat-form-field>
            @if(oxygenSaturationIndicator || oxygenSaturationSuggestion){
            <div class="ref-range-hint small-subtitle">
                <mat-icon [style.color]="oxygenSaturationIndicator?.color || (oxygenSaturationSuggestion?.classification==='high'? '#f44336': oxygenSaturationSuggestion?.classification==='low'? '#2196F3':'#4caf50')">{{oxygenSaturationIndicator?.icon || (oxygenSaturationSuggestion?.classification==='high' ? 'arrow_upward' : (oxygenSaturationSuggestion?.classification==='low' ? 'arrow_downward' : 'check_circle'))}}</mat-icon>
                {{oxygenSaturationIndicator?.category || oxygenSaturationSuggestion?.classification}} — {{oxygenSaturationSuggestion?.description}}
            </div>
            }
        </div>
        }
        <div class="mt-20" style="text-align:right;">
            <button mat-flat-button color="primary" (click)="submitVitals()" [disabled]="isSubmitDisabled">
                Submit Vitals
            </button>
        </div>
    </form>
</div>